import { GpuVector } from "./gpuVector";
//TODO: extend from GeometryVector -> make topology vector optional
export class FlatGpuVector extends GpuVector {
    _geometryTypes;
    constructor(_geometryTypes, triangleOffsets, indexBuffer, vertexBuffer, topologyVector) {
        super(triangleOffsets, indexBuffer, vertexBuffer, topologyVector);
        this._geometryTypes = _geometryTypes;
    }
    static create(geometryTypes, triangleOffsets, indexBuffer, vertexBuffer, topologyVector) {
        return new FlatGpuVector(geometryTypes, triangleOffsets, indexBuffer, vertexBuffer, topologyVector);
    }
    /*static createMortonEncoded(
        geometryTypes: Int32Array,
        triangleOffsets: Int32Array,
        indexBuffer: Int32Array,
        vertexOffsets: Int32Array,
        vertexBuffer: Int32Array,
        mortonInfo: MortonSettings
    ): GpuVector {
        //TODO: refactor to use unsigned integers
        return new FlatGpuVector(
            VertexBufferType.MORTON,
            geometryTypes,
            triangleOffsets,
            indexBuffer,
            vertexOffsets,
            vertexBuffer,
            mortonInfo
        );
    }*/
    geometryType(index) {
        return this._geometryTypes[index];
    }
    get numGeometries() {
        return this._geometryTypes.length;
    }
    containsSingleGeometryType() {
        return false;
    }
}
//# sourceMappingURL=flatGpuVector.js.map